import { message } from 'antd';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CreateAllocatorPayload,
  createAllocatorFailure,
  createAllocatorRequest,
  createAllocatorSuccess,
  fetchAllocatorsFailure,
  fetchAllocatorsRequest,
  fetchAllocatorsSuccess,
  fetchVendorCodeFailure,
  fetchVendorCodeRequest,
  fetchVendorCodeSuccess,
  searchAllocatorsFailure,
  searchAllocatorsRequest,
  searchAllocatorsSuccess,
} from 'redux/slice/agency-onbording/Allocator.slice';
import { agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

const fetchAllocatorsApi = async () => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.GET_ALL_ALLOCATORS
  );
  return response.data;
};

const fetchVendorCodeApi = async (allocatorId: string) => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.GET_ALLOCATOR_VENDOR_CODE(allocatorId)
  );
  return response.data;
};

const searchAllocatorsApi = async (allocatorName: string) => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.SEARCH_ALLOCATORS(allocatorName)
  );
  return response.data;
};

const createAllocatorApi = async (payload: CreateAllocatorPayload) => {
  const response = await HTTPClient.PostRequest(
    agencyOnboarding.CREATE_ALLOCATOR,
    payload
  );
  return response.data;
};

function* fetchAllocatorsSaga(): Generator<any, void, any> {
  try {
    const allocators = yield call(fetchAllocatorsApi);
    yield put(fetchAllocatorsSuccess(allocators));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to fetch allocators';
    yield put(fetchAllocatorsFailure(errorMessage));
  }
}

function* fetchVendorCodeSaga(
  action: ReturnType<typeof fetchVendorCodeRequest>
): Generator<any, void, any> {
  try {
    const allocatorId = action.payload;
    const response = yield call(fetchVendorCodeApi, allocatorId);
    yield put(fetchVendorCodeSuccess({ vendorCode: response.vendorCode }));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to fetch vendor code';
    yield put(fetchVendorCodeFailure(errorMessage));
  }
}

function* searchAllocatorsSaga(
  action: ReturnType<typeof searchAllocatorsRequest>
): Generator<any, void, any> {
  try {
    const allocators = yield call(searchAllocatorsApi, action.payload);
    yield put(searchAllocatorsSuccess(allocators));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to search allocators';
    yield put(searchAllocatorsFailure(errorMessage));
  }
}

function* createAllocatorSaga(
  action: ReturnType<typeof createAllocatorRequest>
): Generator<any, void, any> {
  try {
    const newAllocator = yield call(createAllocatorApi, action.payload);
    yield put(createAllocatorSuccess(newAllocator));
    message.success('Lender created successfully');
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to create lender';
    message.error(errorMessage);
    yield put(createAllocatorFailure(errorMessage));
  }
}

export function* watchAllocatorSaga() {
  yield takeLatest(fetchAllocatorsRequest.type, fetchAllocatorsSaga);
  yield takeLatest(fetchVendorCodeRequest.type, fetchVendorCodeSaga);
  yield takeLatest(searchAllocatorsRequest.type, searchAllocatorsSaga);
  yield takeLatest(createAllocatorRequest.type, createAllocatorSaga);
}
